import React from 'react';
import PropTypes from 'prop-types';

const IconChevronDown = ({ size, fill }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill={fill}
        viewBox="0 300 1792 1792"
    >
        <path d="M1683 808l-742 741q-19 19-45 19t-45-19l-742-741q-19-19-19-45.5t19-45.5l166-165q19-19 45-19t45 19l531 531 531-531q19-19 45-19t45 19l166 165q19 19 19 45.5t-19 45.5z" />
    </svg>
);

IconChevronDown.propTypes = {
    size: PropTypes.number.isRequired,
    fill: PropTypes.string.isRequired,
};

IconChevronDown.defaultProps = {
    size: 15,
    fill: 'white',
};

IconChevronDown.displayName = 'IconChevronDown';

export default IconChevronDown;
